import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getChanges,
    getUsername,
    postChanges,
} from "./approvalApi";

const initialState = {
    data: [],
    dataChanges: [],
    loading: false,
    error: null,
    pageNo: 1,
    pageSize: 10,
    totalRecord: 0,
    selected: null,


};
export const fetchUsername = createAsyncThunk(
    "approval/fetchUsername",
    async (payload) => {
        const response = await getUsername(payload);
        return response;
    }
);

export const fetchChanges = createAsyncThunk(
    "approval/fetchChanges",
    async (payload) => {
        const response = await getChanges(payload);
        return response;
    }
);


export const createChanges = createAsyncThunk(
    "approval/createChanges",
    async (payload) => {
        const response = await postChanges(payload);
        return response;
    }
);

export const approvalSlice = createSlice({
    name: "approval",
    initialState,
    reducers: {
        resetData: (state) => initialState,
        setSelected: (state, action) => {
            state.selected = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchChanges.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchChanges.fulfilled, (state, action) => {
                state.loading = false;
                state.dataChanges = action.payload.data.data;
                state.pageNo = action.payload.pageNo;
                state.pageSize = action.payload.pageSize;
                state.totalRecord = action.payload.totalRecord;
            })
            .addCase(fetchUsername.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUsername.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data.data;
                state.pageNo = action.payload.pageNo;
                state.pageSize = action.payload.pageSize;
                state.totalRecord = action.payload.totalRecord;
            })
            .addCase(createChanges.pending, (state) => {
                state.loading = true;
            })
            .addCase(createChanges.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createChanges.rejected, (state, action) => {
                state.loading = false;
            })

    },
});

export const { resetData, setSelected } = approvalSlice.actions;

export const selectData = (state) => state.approval.data;
export const selectDataChanges = (state) => state.approval.dataChanges;
export const selectLoading = (state) => state.approval.loading;
export const selectError = (state) => state.approval.error;
export const selectPageNo = (state) => state.approval.pageNo;
export const selectPageSize = (state) => state.approval.pageSize;
export const selectTotalRecord = (state) => state.approval.totalRecord;
export const selectSelected = (state) => state.approval.selected;

export default approvalSlice.reducer;
